export const emptyFacilitiesForm = {
  facilities: [],
  states: [],
  primaryFacility: { label: '', value: '' },
};
